import { FuelTag } from '@frete.com/fuel-react';
import { FuelFlex } from '@frete.com/fuel-station-react';
import { DS_TOKENS } from 'constants/styled.contants';
import React, { FC } from 'react';

export interface ITagsProps {
  list: string[];
}

export const Tags: FC<ITagsProps> = ({ list }) => (
  <FuelFlex
    defaultProps={{
      flexWrap: 'wrap',
      customGap: `${DS_TOKENS.spacing.km4} ${DS_TOKENS.spacing.km2}`,
      height: 'min-content',
    }}
  >
    {list?.map((item: string) => (
      <FuelTag label={item} key={`tag-${item}`} shape="ellipse" uppercase={false} />
    ))}
  </FuelFlex>
);
